import { Text, TextProps } from "@mantine/core";


export const ParentsBoxText = ({children} : TextProps) => {
    return <Text size="sm">{children}</Text>
}